export default "__VITE_ASSET__CJT$Hi4b__"